import { getAddressComponents } from './geocode';

export const getAddressFromCoordinates = (lat, lng) => {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        if (!geocoder) {
            reject('Geocoder not initialized');
            return;
        }
        geocoder.geocode(
            { location: { lat: lat, lng: lng } },
            (results, status) => {
                if (status === 'OK' && results.length > 0) {
                    const place = results[0];
                    const result_address_ = getAddressComponents(place);
                    resolve(result_address_);
                } else {
                    reject('Address not found');
                }
            }
        );
    });
};


const mergeStreetAndRoute = (addressComponents) => {
    let route = "";
    let streetNumber = "";

    if (Array.isArray(addressComponents)) {
        for (const component of addressComponents) {
            if (component.types.includes("route")) {
                route = component.long_name;
            } else if (component.types.includes("street_number") ||
                component.types.includes("airport") ||
                component.types.includes("establishment") ||
                component.types.includes("point_of_interest")) {
                streetNumber = component.long_name;
            }
        }
    }

    return `${streetNumber} ${route}`.trim();
};

export const getAddressComponentByType = (addressComponents, desiredTypes) => {
    const components = addressComponents.address_components;
    if (!components) return null;

    const mergedStreetAndRoute = mergeStreetAndRoute(components);
    if (Array.isArray(components)) {
        for (const component of components) {
            if (component.types.some(type => desiredTypes.includes(type))) {
                if (desiredTypes[0] === "postal_code") {
                    return component.short_name;
                } else if (desiredTypes[0] === "route") {
                    if (mergedStreetAndRoute !== "") {
                        return mergedStreetAndRoute;
                    } else {
                        return component.long_name;
                    }
                } else if (desiredTypes[0] === "administrative_area_level_1") {
                    return component;
                } else {
                    return component.long_name;
                }
            }
        }
    }
    return null;
};


export const desiredTypes = [
    'street_number',
    'route',
    'neighborhood',
    'sublocality',
    'locality',
    'administrative_area_level_2',
    'administrative_area_level_1',
    'country',
    'postal_code',
    'airport',
    'establishment',
    'point_of_interest',
];
